// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ContributionCategoryModel from '../../model/contribution-category-model';
import ContributionCategoryDTO from '../dto/contribution-category-dto';
import dtoSchema from '../schemas/contribution-category-schema';

export default abstract class ContributionCategoryModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ContributionCategoryDTO>) {
    super();
    if (data) {
      this.contributionCategoryOrganisationId = data.contributionCategoryOrganisationId ?? undefined;
      this.contributionCategoryId = data.contributionCategoryId ?? undefined;
      this.contributionCategoryName = data.contributionCategoryName ?? undefined;
    }
  }
  /**
  * @type {uuid}
  */
  contributionCategoryOrganisationId?: string;
  /**
  * @type {uuid}
  */
  contributionCategoryId?: string;
  /**
  */
  contributionCategoryName?: string;

  static toModel(dto: DeepPartial<ContributionCategoryDTO>): ContributionCategoryModel;
  static toModel(dto: DeepPartial<ContributionCategoryDTO> | undefined | null): ContributionCategoryModel | undefined;
  static toModel(dto: DeepPartial<ContributionCategoryDTO> | undefined | null): ContributionCategoryModel | undefined {
    return dto ? new ContributionCategoryModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ContributionCategoryModel> | ContributionCategoryModel): ContributionCategoryDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      contributionCategoryOrganisationId: unwrapped.contributionCategoryOrganisationId,
      contributionCategoryId: unwrapped.contributionCategoryId,
      contributionCategoryName: unwrapped.contributionCategoryName,
    } as ContributionCategoryDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ContributionCategoryModel, can not map to ContributionCategoryDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
